import { Model } from 'modules/core/lib/mobx-rest'

interface IImport {
  [key: string]: any
}

class DataImport extends Model<IImport> {
  static urlRoot() {
    return '/payroll/data_imports'
  }
}

export default DataImport
